module.exports = __webpack_public_path__ + "img/photo01.141fa634.jpg";